<section class="dashboard-page">

    <div class="dashboard-heading mb-3">

        <div>

            <span class="dashboard-eyebrow">
                GENEL BAKIŞ
            </span>

            <h1>
                İyi günler, Gökçen.
            </h1>

        </div>

        <div class="dashboard-heading-actions">

            <button type="button" class="outline-button">
                <i class="bi bi-clock-history"></i>
                Aktivite
            </button>

            <button type="button" class="primary-button">
                <i class="bi bi-plus-lg"></i>
                Yeni Proje
            </button>

        </div>

    </div>



    <!-- =====================================================
         HIZLI UYGULAMALAR
    ====================================================== -->

  <section class="quick-apps-panel card border-0 mb-3">
  <div class="card-body quick-apps-body">

    <!-- HEADER -->
    <div class="quick-apps-header">
      <div class="quick-apps-header-left">

        <div class="quick-apps-header-icon">
          <span></span>
          <span></span>
          <span></span>
       
     
        </div>

        <div class="quick-apps-header-text">
          <h3 class="quick-apps-title">
            {{ title }}
          </h3>

        </div>

      </div>

      <button
        type="button"
        class="btn quick-apps-view-all"
        (click)="OpenAllApplications()">
        {{ viewAllText }}
        <i class="bi bi-arrow-right"></i>
      </button>
    </div>

    <!-- SCROLL AREA -->
    <div class="quick-apps-scroll-wrapper">

      <button
        type="button"
        class="scroll-nav scroll-nav-left"
        [class.is-hidden]="!canScrollLeft"
        (click)="ScrollLeft()">
        <i class="bi bi-chevron-left"></i>
      </button>

      <div
        #scrollViewport
        class="quick-apps-scroll"
        (scroll)="OnScroll()">

        <div class="quick-apps-list">
     <button
  type="button"
  class="quick-app-card"
  *ngFor="let item of quickApplications; trackBy: trackByApplication"
  (click)="OpenApplication(item)">

  <div class="quick-app-logo-wrap">
    <img
      class="quick-app-logo"
      [src]="item.logoUrl"
      [alt]="item.name"
    />
  </div>

  <div class="quick-app-name">
    {{ item.name }}
  </div>


</button>
        </div>

      </div>

      <button
        type="button"
        class="scroll-nav scroll-nav-right"
        [class.is-hidden]="!canScrollRight"
        (click)="ScrollRight()">
        <i class="bi bi-chevron-right"></i>
      </button>

    </div>

  </div>
</section>

    <!-- =====================================================
         WELCOME
    ====================================================== -->

    <section class="welcome-panel">

     <section class="welcome-company-panel">

  <!-- =========================================================
       BACKGROUND IMAGE
       LOGO BU GÖRSELİN İÇİNDE
  ========================================================== -->
  <div class="welcome-visual"></div>


  <!-- =========================================================
       LEFT CONTENT
  ========================================================== -->
  <div class="welcome-content">

    <div class="welcome-title">
      <span>Hoş geldiniz</span>
      <span class="welcome-title-dot"></span>
    </div>


    <div class="company-row">

      <div class="company-icon">
        <i class="bi bi-buildings-fill"></i>
      </div>

      <div class="company-info">

        <h2>
          {{ companyName }}
        </h2>

        <span class="company-type">
          {{ companyType }}
        </span>

      </div>

    </div>


    <div class="company-statistics">


        <!-- SUBSCRIPTION -->
      <div class="stat-item subscription-stat">
        <div class="my-boldlabel">
        <div class="stat-label">
          Abonelik Durumu
        </div>

        <div class="subscription-status">

          <span class="status-dot"></span>

          <strong>
            {{ subscriptionStatus }}
          </strong>

        </div>

        <div class="subscription-date">
          {{ subscriptionExpireDate }}'ya kadar
        </div>
       </div>
      </div>

   

      <div class="stat-divider"></div>


      <!-- ACTIVE USER -->
      <div class="stat-item user-stat">

        <div class="stat-label">
          Aktif Kullanıcı
        </div>

        <div class="active-user-row">

          <i class="bi bi-person"></i>

          <strong>
            {{ activeUserCount }} / {{ userLimit }}
          </strong>

        </div>

      </div>


      <div class="stat-divider"></div>

   <!-- PACKAGE -->
      <div class="stat-item package-stat">

        <div class="stat-label">
          Paket
        </div>

        <div class="package-badge">
          {{ packageName }}
        </div>

      </div>

      
    </div>

  </div>


  <!-- =========================================================
       RIGHT DESCRIPTION
  ========================================================== -->
  <div class="welcome-description">

    <p>
      Tüm uygulamalarınıza,<br />
      hizmetlerinize, API'lerinize,<br />
      kütüphanelerinize ve<br />
      online sistemlerinize<br />
      tek yerden erişin.
    </p>

  </div>

</section>

        <div class="customer-panel">

            <div class="customer-panel-top">

                <span class="customer-label">
                    KURUMSAL HESAP
                </span>

                <span class="customer-status">
                    <i></i>
                    Aktif
                </span>

            </div>

            <div class="customer-company">

                <div class="customer-logo">
                    A
                </div>

                <div>
                    <strong>ANAMETA</strong>
                    <span>Information Technologies</span>
                </div>

            </div>

            <div class="customer-details">

                <div>
                    <span>Hesap Türü</span>
                    <strong>Kurumsal</strong>
                </div>

                <div>
                    <span>Projeler</span>
                    <strong>8 Aktif</strong>
                </div>

                <div>
                    <span>Kullanıcılar</span>
                    <strong>4 Üye</strong>
                </div>

                <div>
                    <span>Plan</span>
                    <strong>Enterprise</strong>
                </div>

            </div>

            <button type="button" class="customer-manage-button">
                Şirketi Yönet

                <i class="bi bi-chevron-right"></i>
            </button>

        </div>

    </section>


    <!-- =====================================================
         SUMMARY CARDS
    ====================================================== -->

    <section class="summary-grid">

        <article class="summary-card">

            <div class="summary-icon projects-icon">
                <i class="bi bi-kanban"></i>
            </div>

            <div class="summary-content">
                <span>Toplam Proje</span>

                <strong>8</strong>

                <small>
                    <i class="bi bi-arrow-up-right"></i>
                    2 yeni proje
                </small>
            </div>

        </article>

        <article class="summary-card">

            <div class="summary-icon applications-icon">
                <i class="bi bi-grid-3x3-gap"></i>
            </div>

            <div class="summary-content">
                <span>Aktif Uygulama</span>

                <strong>12</strong>

                <small>
                    5 ürün kullanılıyor
                </small>
            </div>

        </article>

        <article class="summary-card">

            <div class="summary-icon members-icon">
                <i class="bi bi-people"></i>
            </div>

            <div class="summary-content">
                <span>Ekip Üyeleri</span>

                <strong>4</strong>

                <small>
                    3 kullanıcı çevrimiçi
                </small>
            </div>

        </article>

        <article class="summary-card">

            <div class="summary-icon services-icon">
                <i class="bi bi-activity"></i>
            </div>

            <div class="summary-content">
                <span>Servis Durumu</span>

                <strong>%99.9</strong>

                <small class="positive">
                    Tüm sistemler çalışıyor
                </small>
            </div>

        </article>

    </section>


    <!-- =====================================================
         LOWER GRID
    ====================================================== -->

    <section class="dashboard-main-grid">

        <!-- PROJECTS -->

        <article class="dashboard-card projects-card">

            <div class="card-header">

                <div>
                    <span class="card-eyebrow">
                        ÇALIŞMA ALANI
                    </span>

                    <h3>
                        Son Projeler
                    </h3>
                </div>

                <a routerLink="/projects">
                    Tüm Projeler
                    <i class="bi bi-arrow-right"></i>
                </a>

            </div>

            <div class="project-list">

                <div class="project-item" *ngFor="let project of projects">

                    <div class="project-logo" [ngClass]="project.colorClass">
                        {{ project.shortName }}
                    </div>

                    <div class="project-info">

                        <div class="project-name">
                            <strong>{{ project.name }}</strong>

                            <span [ngClass]="project.statusClass">
                                {{ project.status }}
                            </span>
                        </div>

                        <span class="project-description">
                            {{ project.description }}
                        </span>

                    </div>

                    <div class="project-type">
                        {{ project.type }}
                    </div>

                    <button type="button" class="project-button">
                        <i class="bi bi-chevron-right"></i>
                    </button>

                </div>

            </div>

        </article>


        <!-- RIGHT COLUMN -->

        <div class="dashboard-side-column">

            <article class="dashboard-card activity-card">

                <div class="card-header">

                    <div>
                        <span class="card-eyebrow">
                            SON 7 GÜN
                        </span>

                        <h3>
                            Kullanım
                        </h3>
                    </div>

                    <button type="button" class="card-options">
                        <i class="bi bi-three-dots"></i>
                    </button>

                </div>

                <div class="activity-value">

                    <strong>14.8K</strong>

                    <span>
                        <i class="bi bi-arrow-up-right"></i>
                        %18.4
                    </span>

                </div>

                <p>
                    Toplam uygulama ve servis isteği
                </p>

                <div class="mini-chart">

                    <div
                        class="chart-column"
                        *ngFor="let value of chartValues; let index = index"
                    >

                        <div
                            class="chart-bar"
                            [style.height.%]="value"
                            [class.active]="index === 6"
                        ></div>

                    </div>

                </div>

                <div class="chart-labels">
                    <span>Pzt</span>
                    <span>Sal</span>
                    <span>Çar</span>
                    <span>Per</span>
                    <span>Cum</span>
                    <span>Cmt</span>
                    <span>Paz</span>
                </div>

            </article>


            <article class="dashboard-card mini-news-card">

                <div class="news-card-icon">
                    <i class="bi bi-megaphone"></i>
                </div>

                <div class="news-card-content">

                    <span>
                        ANAMETA NEWS
                    </span>

                    <strong>
                        Observability Agent yayınlandı.
                    </strong>

                    <a href="#">
                        Detayları Gör
                        <i class="bi bi-arrow-right"></i>
                    </a>

                </div>

            </article>

        </div>

    </section>

        <!-- =====================================================
         HABER BANDI
    ====================================================== -->

    <section class="news-strip">

        <div class="breaking-label">
            <span></span>
            ONE NEWS
        </div>

        <div class="breaking-content">

            <div class="breaking-track">
                <span>
                    ANAMETA Digital Observability yeni nesil Agent altyapısı kullanıma açıldı.
                </span>

                <i></i>

                <span>
                    ANAMETA ONE Marketplace üzerindeki yeni uygulamalar yayınlandı.
                </span>

                <i></i>

                <span>
                    Sistem bakım çalışmaları 25 Eylül tarihinde gerçekleştirilecektir.
                </span>
            </div>

        </div>

        <a class="news-link" href="#">
            Tüm Haberler
            <i class="bi bi-arrow-right"></i>
        </a>

    </section>


</section>